import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Use_Of_Alternative_Instrument_Filter from "./use_of_alternative_instrument_filter/Use_Of_Alternative_Instrument_Filter";
import Use_Of_Alternative_Instrument_Table from "./use_of_alternative_instrument_table/Use_Of_Alternative_Instrument_Table";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Use_Of_Alternative_Instrument = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.use_of_alternative_instrument_report.Report,
  );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Use_Of_Alternative_Instrument_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Use_Of_Alternative_Instrument_Table
            validitydetails={validitydetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </section>
  );
};

export default Use_Of_Alternative_Instrument;
